import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles({
  subTitle: { paddingLeft: 30 },
  infoGroup: { margin: '5px auto 5px auto', maxWidth: 600 },
  row: { margin: '10px 0px 10px 0px' },
  docName: { textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }
})
